export const experiencesQueryKeys = {
  all: ['experiences'] as const,
  collections: () => [...experiencesQueryKeys.all, 'collections'] as const,
  collectionsList: (onlyActive?: boolean) => [...experiencesQueryKeys.collections(), { onlyActive }] as const,
  carouselMetrics: () => [...experiencesQueryKeys.all, 'carouselMetrics'] as const,
  carouselMetricsList: () => [...experiencesQueryKeys.carouselMetrics(), 'list'] as const,
  syncLogs: () => [...experiencesQueryKeys.all, 'syncLogs'] as const,
  syncLogsList: (offerId: string) => [...experiencesQueryKeys.syncLogs(), offerId] as const,
};
